import React from "react";

export default function currentTimeDate(props) {
  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  let months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  let now = new Date();
  let weekDay = days[now.getDay()];
  let month = months[now.getMonth()];
  let day = now.getDate();
  let hour = now.getHours();
  let minutes = now.getMinutes();
  let date = `${weekDay} ${month} ${day} `;
  let time = `${hour}:${minutes}`;

  return (
    <div className="col-6">
      <div>
        <div className="City">{props.city}</div>
        <div className="current-date">{date}</div>
        <div className="current-time">Last Updated: {time}</div>
      </div>
    </div>
  );
}
